/******************
 * Vinova Themes  Framework for Prestashop 1.7.x 
 * @package    Nova - PrestaShop 1.7 Theme For Fashion Templates
 * @version    1.0
 * @author    http://vinovathemes.com/
 * @copyright  Copyright (C) October 2013 vinovathemes.com <@emai:vinovathemes@gmail.com>
 * <info@vinovathemes.com>.All rights reserved.
 * @license   GNU General Public License version 1
 * *****************/
/*
 * Custom code goes here.
 * A template should always ship with an empty custom.js
 */

 

$('.section-collection-list').css('background-color','#f2f2f2').css('padding-top', '15px');
$('.section-collection-list .page-width').css('padding-bottom','55px');

$('.home-coll-title').css('margin','18px');
$('.home-coll-name').css('width','85%');
$('.home-coll-view-all').css('margin-top','30px');

$('.btn-home-coll-view-all').css('width', '150px');

/* home page collections list custom style end */

$('#NovBreadcrumbs').css('margin','0px');

// remove view books button from collection list page
$('#glx-collection-list .home-coll-name').remove(); 

$('#glx-home-collections .glx-collections-list-item').remove(); 

function hideViewButton(){
   $('.glx-collections-list-item').addClass('hidden');
}
function showViewButton(pid){
   hideViewButton();
   $('#glx_item_view_'+pid).removeClass('hidden'); 
}

$('#glx-collection-list .mb-10').css('padding-right','60px');

$('.dropdown-menu.dropdown-menu-right').removeClass('text-right');

$('#stickymenu_bottom_mobile').remove();



function hideStates(ctry_code){
  if(ctry_code=='')
    $('#divStateProvinceFilter').hide();
  else
    $('#divStateProvinceFilter').show();      
}

$(document).on('click', '.tag-filter-li', function(){         
	hideFilterTags();

});


 var hideFilterTags = function(){
  
  	$('#li-'+$('#divCountryList').val().toLowerCase()).hide();
  
  	if($('#divCountryList').val() == 'US'){
      	$('#li-'+$('#divStatesUS').val().toLowerCase()).hide(); 
    }else  if($('#divCountryList').val() == 'CA'){
     	$('#li-'+$('#divStatesCA').val().toLowerCase()).hide();            
     }
};


function  hideStatesOfCA(){
  $('.StatesList').addClass('hidden');
  
  if($('#divStatesCA').hasClass('hidden'))
    	$('#divStatesCA').removeClass('hidden');  
}

function hideStatesOfUS(){
  if($('#divStatesUS').hasClass('hidden'))
    	$('#divStatesUS').removeClass('hidden');
}


function setDefaultStateOfUS(){
  
  if($('#divStatesUS').val() ==''){ 
           $('#divStatesUS').val('arizona');           
   }
}

function setDefaultStateOfCA(){
    if($('#divStatesCA').val() ==''){ 
           $('#divStatesCA').val('alberta');           
    }      
}
